import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function getFormArrayAsDataArray(formGroup: UntypedFormGroup, formArrayName: string): Array<any> {
  return this.geValuesFromFormArray(formGroup.get(formArrayName) as UntypedFormArray);
}

export function geValuesFromFormArray(formArray: UntypedFormArray): Array<any> {
  const values = [];
  formArray.controls.forEach((control) => {
    values.push(control.value);
  });
  return values;
}

export const nameof = <T>(name: keyof T) => name;

export function groupBy<TKey, TValue>(items: TValue[], key: keyof TValue): Map<TKey, TValue[]> {
  return items.reduce((map, item, idx, arr) => {
    if (map.has(item[key])) {
      const groupItems = map.get(item[key]);
      const newGroupItems = [...groupItems, item];
      map.set(item[key], newGroupItems);
    } else {
      map.set(item[key], [item]);
    }

    return map;
  }, new Map());
}

export function removeFromArray<T>(arr: T[], values: T[]) {
  for (let i = 0; i < values.length; i++) {
    const ind = arr?.findIndex((col) => col === values[i]);
    if (ind > -1) {
      arr?.splice(ind, 1);
    }
  }
}

export function compareTwoArrays<T>(arr1: T[], arr2: T[]) {
  return arr1.length === arr2.length && arr1.every((element, index) => element === arr2[index]);
}

export function getSumOfNumberArray(arr: number[]): number {
  return arr.reduce((prev, current) => prev + current, 0);
}

export function getFileSizeInMegabytes(fileSizeInBytes: number) {
  return fileSizeInBytes / Math.pow(1024, 2);
}
